import { ChatRoomResponse } from '../types';

import axiosInstance from './axiosInstance';

export async function getRoom(roomUuid: string) {
  const response = await axiosInstance.get(`/rooms/${roomUuid}`);
  return response.data as ChatRoomResponse;
}
